import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  ReleaseLock: (releaseRequest) => {
    try {
      return _svc.post('Lock/Release', releaseRequest)
    } catch {
      return null
    }
  },
  SetLock: (lockRequest) => {
    try {
      return _svc.post('Lock', lockRequest)
    } catch {
      return null
    }
  }
}
